import { Component } from '@angular/core';
import { Module } from '@library/store/modules/modules.interface';
import { EnergyReportsFacade } from '@store/energy-reports/energy-reports.facade';
import { combineLatest } from 'rxjs';
import { ControlPageReportsService } from '../../control-page-reports.service';

@Component({
  selector: 'app-cp-reports-device-selector',
  templateUrl: './cp-reports-device-selector.component.html',
  styleUrl: './cp-reports-device-selector.component.scss',
})
export class CpReportsDeviceSelectorComponent {

  viewModel$ = combineLatest({
    reportDevices: this.energyReportsFacade.reportGateways$,
    currentDevice: this.controlPageReportsService.reportDevice$,
  });

  constructor(
    private energyReportsFacade: EnergyReportsFacade,
    private controlPageReportsService: ControlPageReportsService) {
  }

  selectPreviousThermostat(devices: Module[], currentDevice: Module) {
    const currentId = devices.findIndex(device => device.id === currentDevice.id);

    if (this.hasPreviousDevice(devices, currentDevice)) {
      this.energyReportsFacade.resetReport();
      this.controlPageReportsService.reportDevice$.next(devices[currentId - 1]);
    }
  }

  selectNextThermostat(devices: Module[], currentDevice: Module) {
    const currentId = devices.findIndex(device => device.id === currentDevice.id);
    if (this.hasNextDevice(devices, currentDevice)) {
      this.energyReportsFacade.resetReport();
      this.controlPageReportsService.reportDevice$.next(devices[currentId + 1]);
    }
  }

  hasPreviousDevice(devices: Module[], currentDevice: Module) {
    const currentId = devices.findIndex(device => device.id === currentDevice.id);
    return currentId > 0;
  }

  hasNextDevice(devices: Module[], currentDevice: Module) {
    const currentId = devices.findIndex(device => device.id === currentDevice.id);
    return currentId  < devices.length -1;
  }
}

